import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Accordion from '@zenbusiness/zui/Accordion';
import AccordionDetails from '@zenbusiness/zui/AccordionDetails';
import AccordionSummary from '@zenbusiness/zui/AccordionSummary';
import Box from '@zenbusiness/zui/Box';
import Text from '@zenbusiness/zui/Text';

import { messageFormatValues as sharedMessageFormatValues } from '#client/pages/ProductLanding/utils/messageFormatValues';

import * as Styled from './FaqItem.style';

const messageFormatValues = {
  ...sharedMessageFormatValues,
  ul: (chunks) => <Styled.FaqList>{chunks}</Styled.FaqList>,
  li: (chunks) => <Box component="li">{chunks}</Box>,
};

function FaqItem({ item: { question, answer }, disableGutters }) {
  return (
    <Accordion gap={2} disableGutters={disableGutters}>
      <AccordionSummary expandIcon={<Styled.ExpandIcon />}>
        <FormattedMessage id={question} />
      </AccordionSummary>
      <AccordionDetails>
        <Text component="p">
          <FormattedMessage id={answer} values={messageFormatValues} />
        </Text>
      </AccordionDetails>
    </Accordion>
  );
}

FaqItem.propTypes = {
  item: PropTypes.shape({
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired,
  }).isRequired,
  disableGutters: PropTypes.bool,
};
export default FaqItem;
